<template>
  <div id="expertises">
    <div class="container">
      <h2 class="title">Expertises</h2>
      <div
        class="container-expertises"
        data-aos="fade-up"
        data-aos-delay="1000"
        data-aos-duration="1000"
      >
        <div class="content-expertise">
          <h3>Frameworks</h3>
          <hr />
          <ul>
            <li v-for="(frameworks, index) in frameworks" :key="index">
              <img
                :src="require(`@/assets/${frameworks.image}`)"
                :alt="frameworks.alt"
                loading="lazy"
              />
              <span>{{ frameworks.title }}</span>
            </li>
          </ul>
        </div>

        <div class="content-expertise">
          <h3>Front end</h3>
          <hr />
          <ul>
            <li v-for="(frontend, index) in frontend" :key="index">
              <img
                :src="require(`@/assets/${frontend.image}`)"
                :alt="frontend.alt"
                loading="lazy"
              />
              <span>{{ frontend.title }}</span>
            </li>
          </ul>
        </div>

        <div class="content-expertise">
          <h3>UX</h3>
          <hr />
          <ul>
            <li v-for="(ux, index) in ux" :key="index">
              <img
                :src="require(`@/assets/${ux.image}`)"
                :alt="ux.alt"
                loading="lazy"
              />
              <span>{{ ux.title }}</span>
            </li>
          </ul>
        </div>

        <div class="content-expertise">
          <h3>UI</h3>
          <hr />
          <ul>
            <li v-for="(ui, index) in ui" :key="index">
              <img
                :src="require(`@/assets/${ui.image}`)"
                :alt="ui.alt"
                loading="lazy"
              />
              <span>{{ ui.title }}</span>
            </li>
          </ul>
        </div>

        <div class="content-expertise">
          <h3>Databases</h3>
          <hr />
          <ul>
            <li v-for="(database, index) in database" :key="index">
              <img
                :src="require(`@/assets/${database.image}`)"
                :alt="database.alt"
                loading="lazy"
              />
              <span>{{ database.title }}</span>
            </li>
          </ul>
        </div>

        <div class="content-expertise">
          <h3>Otimizadores</h3>
          <hr />
          <ul>
            <li v-for="(otimizadores, index) in otimizadores" :key="index">
              <img
                :src="require(`@/assets/${otimizadores.image}`)"
                :alt="otimizadores.alt"
                loading="lazy"
              />
              <span>{{ otimizadores.title }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/storeData.js";

export default {
  data() {
    return {
      frontend: store.frontend,
      ux: store.ux,
      ui: store.ui,
      frameworks: store.frameworks,
      database: store.database,
      otimizadores: store.otimizadores
    };
  }
};
</script>
